'use client'; // Error components must be Client Components

import { useSpinnerContext } from '@/context/SpinnerContext';
import { triggerEvent } from '@/lib/events';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { startLoaderEvent, stopLoaderEvent } = useSpinnerContext();
  useEffect(() => {
    // Log the error to an error reporting service
    triggerEvent(stopLoaderEvent);
  }, [error, stopLoaderEvent]);
  const { t } = useTranslation('common');

  return (
    <div>
      <h2>{t('generalError')}</h2>
      <button
        name="reset-button"
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }
      >
        {t('tryAgain')}
      </button>
    </div>
  );
}
